import '~/js/modules/countdown';
import '~/js/modules/stickyNav';
import '~/js/modules/subscribe-form';

import ResortsDeals from '~/js/components/specials/last-minute-deals/resorts-deals';

const resortsDeals = document.querySelector('#js-last-minute-deals');
const lastMinuteDeals = {...beaches_app.page.lastMinuteDeals};
const resortsSummary = {...beaches_app.page.resortsSummary};


$(function () {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const resortCode= urlParams.get('rstCode');

  var resort= $("#" + resortCode);

  $('html, body').animate({ 
      scrollTop: resort.offset().top - 290
  }, 'slow');

});

// const deals = [
//   { arrivalMonth: 10, bookedDataHigh: '2018-10-31', bookedDateLow: '2018-10-27', description: 'LAST MINUTE DEAL - FIRST NIGHT FREE ON 3 NIGHT STAYS!', numberOfDaysStay: 3, promotionId: 40809, promotionName: '519-LAST MINUTE DEAL', rstCode: 'BBO', stayDateHigh: '2018-12-01', stayDateLow: '2018-10-31' },
//   { arrivalMonth: 10, bookedDataHigh: '2018-11-01', bookedDateLow: '2018-10-28', description: 'LAST MINUTE DEAL - FIRST NIGHT FREE ON 3 NIGHT STAYS!', numberOfDaysStay: 3, promotionId: 40809, promotionName: '519-LAST MINUTE DEAL', rstCode: 'BBO', stayDateHigh: '2018-12-01', stayDateLow: '2018-10-31' }
// ];
// const lastDeals = {BBO: {month_10: deals}, BTC: {month_10: deals}};

ReactDOM.render(
  <ResortsDeals
    lastMinuteDeals={lastMinuteDeals}
    resortsSummary={resortsSummary}
    cdnURL={beaches_app.page.cdnURL}
  />, resortsDeals
);

